// Mock data for Read Right Academy

export const testimonials = [
  {
    id: 1,
    name: "Arthi Vijayakumar (Diya's Mom)",
    image: "https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/g6d9e7hd_Diya.jpg",
    content: "It was during Covid time I was looking for a teacher who can help my 4 year old daughter to start with reading and math. That's when I came across Kalah teacher. I was very much impressed by the way she handled kids. She is very friendly, teaches concepts in a fun way that kids can never forget. She has created great educational foundation for my daughter. My daughter is in 1st grade now. Even now Kalah teacher is her best teacher. My favorite too 😊"
  },
  {
    id: 2,
    name: "Dr.Sarvinaa (Jaykrsh and Sanvi's Mom)",
    image: "https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/e02aafd4_JK%20Sanvi.jpg",
    content: "I was looking high and low and determined to find materials and proper channels to help my children with reading skills. RRA has been a brilliant choice. Both my children have become strong and confident readers in a short span of time. Teacher Kalah knows her ways with kids and is dedicated enough to keep them engaged throughout her tutoring."
  },
  {
    id: 3,
    name: "Kangana (Myra's Mom)",
    image: "https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/3wy390i3_Myra.jpg",
    content: "Reading has changed my child in incredible ways. She has a vivid imagination and makes up her own stories (based on stories she has read). She is starting to read classics now (Peter pan, little women, and now onto Heidi). Because of her enhanced reading abilities, she is now able to read lyrics and read music, and is a budding guitarist! Read Right Academy is the best thing that could happen to us, and with Teacher Kalah's innate patient personality, the kids are able to absorb basic reading skills so fast!"
  },
  {
    id: 4,
    name: "Shruti (Shloka & Arjun's Mom)",
    image: "https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/manrtsua_Shloka%20Arjun.jpg",
    content: "\"Reading is one of the greatest gifts you can give to children\". As an avid reader myself, I always wanted my children to enjoy reading books as much as I did. But as any mother to two toddler kids, I was clueless on how to get started. I consider myself very lucky to have met teacher Kalah 3 years ago. She started teaching my daughter when she was 4 and when she could barely read a word. Now, she could read chapter books with ease all thanks to teacher Kalah. My younger son is also now enjoying reading with teacher Kalah. After 4 years, teacher Kalah is more like a family to us ❤️"
  },
  {
    id: 5,
    name: "Melinda (Axl's Mom)",
    image: "https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/0d3z6ofa_Axl.jpg",
    content: "RRA has been a wonderful choice for Axl. Despite being delivered online, Teacher Kala is very engaging and is creative in delivering her lessons. Axl is able to read in under 2 months. Now he doesn't only look at pictures in books, he even reads road signage! I also can see how he tries to work out sounds of new (longer) words and I am glad RRA laid the best foundation for him!"
  }
];

export const programs = [
  {
    id: 1,
    title: "Early Reading & Phonics",
    description: "Structured phonics instruction that builds strong foundations in reading through sound awareness, letter recognition, and blending.",
    features: [
      "Sound awareness development",
      "Letter recognition",
      "Blending techniques",
      "Reading fluency building"
    ],
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Writing & Comprehension",
    description: "Support for developing writing skills and reading comprehension through meaningful, structured activities.",
    features: [
      "Letter formation",
      "Sentence building",
      "Reading comprehension",
      "Creative writing"
    ],
    icon: "PenTool"
  },
  {
    id: 3,
    title: "Kindergarten Readiness",
    description: "Comprehensive preparation that ensures children enter kindergarten with confidence and essential learning skills.",
    features: [
      "Pre-reading skills",
      "Fine motor development",
      "Social readiness",
      "Learning confidence"
    ],
    icon: "GraduationCap"
  },
  {
    id: 4,
    title: "Parent Workshops",
    description: "Practical guidance for parents on supporting early literacy and child development at home.",
    features: [
      "Early literacy strategies",
      "At-home activities",
      "Child development insights",
      "Q&A sessions"
    ],
    icon: "Users"
  },
  {
    id: 5,
    title: "Teacher Training",
    description: "Professional development programs for educators in phonics instruction and early reading methods.",
    features: [
      "Phonics methodology",
      "Classroom strategies",
      "Curriculum planning",
      "Practical training"
    ],
    icon: "Award"
  },
  {
    id: 6,
    title: "Educator Mentoring",
    description: "One-on-one mentoring for aspiring early childhood educators to develop teaching skills and confidence.",
    features: [
      "Personalized guidance",
      "Classroom observation",
      "Skill development",
      "Career support"
    ],
    icon: "Heart"
  }
];

export const stats = [
  {
    value: "20+",
    label: "Years of Experience"
  },
  {
    value: "500+",
    label: "Children Supported"
  },
  {
    value: "100+",
    label: "Teachers Trained"
  },
  {
    value: "95%",
    label: "Success Rate"
  }
];

export const faqs = [
  {
    question: "What age group do you work with?",
    answer: "Our programs are designed for children aged 3-7 years, focusing on early literacy development and kindergarten readiness. We also support older children who need additional reading support."
  },
  {
    question: "How is your approach different?",
    answer: "We believe in preparing the child first, not rushing into reading. Our structured, step-by-step approach respects each child's pace while building confidence, sound awareness, and a genuine love for learning."
  },
  {
    question: "Do you offer online programs?",
    answer: "Yes, we offer both in-person and online programs. Parent workshops and teacher training are available in flexible formats to suit your needs."
  },
  {
    question: "Can parents attend the training programs?",
    answer: "Absolutely! Our parent workshops are specifically designed to equip parents with knowledge and practical strategies to support their children's literacy development at home."
  },
  {
    question: "What qualifications does Kalah have?",
    answer: "Kalah K. Singam is an experienced Early Childhood Educator, Montessori Trainer, and Teacher Trainer with over 20 years of hands-on experience in teaching, curriculum development, and educator mentoring."
  }
];